import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { QueryParameters } from "@faire/retailer-visitor-shared/paths/category/QueryParameters";
import { InvalidSuppliersPathError } from "@faire/retailer-visitor-shared/paths/suppliers/InvalidSuppliersPathError";
import { logWarning } from "@faire/web--source/common/logging";
import { isTupleOfLength } from "@faire/web--source/common/typescriptUtils";
import { prependLocaleToUrl } from "@faire/web--source/ui/routing/util";
import { path as c1SuppliersPath } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId";
import { path as c2SuppliersPath } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/subcategory/c2SuppliersUrlId";
import { path as c3SuppliersPath } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/subcategory/c2SuppliersUrlId/c3SuppliersUrlId";
export var suppliersPath = function(param) {
    var urlIds = param.urlIds, _param_queryParams = param.queryParams, queryParams = _param_queryParams === void 0 ? {} : _param_queryParams, routingContext = param.routingContext;
    var urlIdStrings = urlIds.map(function(urlId) {
        return urlId.id;
    });
    var suppliersPath = "";
    if (isTupleOfLength(urlIdStrings, 1)) {
        suppliersPath = c1SuppliersPath.apply(void 0, _to_consumable_array(urlIdStrings));
    } else if (isTupleOfLength(urlIdStrings, 2)) {
        suppliersPath = c2SuppliersPath.apply(void 0, _to_consumable_array(urlIdStrings));
    } else if (isTupleOfLength(urlIdStrings, 3)) {
        suppliersPath = c3SuppliersPath.apply(void 0, _to_consumable_array(urlIdStrings));
    } else {
        // Category path is larger than the longest possible value. Log a warning and return the longest possible chain
        logWarning(new InvalidSuppliersPathError("Tried to craft suppliers path with URL ID longer than 3 levels. URL IDs ".concat(urlIdStrings)));
        suppliersPath = c3SuppliersPath.apply(void 0, _to_consumable_array(urlIdStrings.slice(0, 3)));
    }
    // TODO: Once query parameters are properly defined on the backend, should be able to remove the localize path
    // and manually formatting the query parameters
    return prependLocaleToUrl(decodeURIComponent(suppliersPath) + QueryParameters.stringify(queryParams, {
        addQueryPrefix: true
    }), routingContext);
};
